
  // import mapboxgl from 'mapbox-gl';
  import studentStories from '~/data/studentStories.json';
  
  export default {
    name: 'InteractiveMap',
    props: {
        region: {
          type: String,
          default: 'England'
        },
        mapstyle: {
          type: String,
          default: 'mapbox://styles/mapbox/outdoors-v11'
        }
    },
    data() {
      return {
        map: null,
        isMapboxLoaded:false,
        england: [
            { name: 'Ashford', coordinates: [0.8775, 51.1480], info: 'TEFL courses in Ashford', link: '/courses/locations/england/ashford', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Ashford_final.jpg' },
            { name: 'Birmingham', coordinates: [-1.8986, 52.4862], info: 'TEFL courses in Birmingham', link: '/courses/locations/england/birmingham', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Birmingham_final.jpeg' },
            { name: 'Bournemouth', coordinates: [-1.8808, 50.7192], info: 'TEFL courses in Bournemouth', link: '/courses/locations/england/bournemouth', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Bournemouth_final.jpg' },
            { name: 'Brighton', coordinates: [-0.1357, 50.8284], info: 'TEFL courses in Brighton', link: '/courses/locations/england/brighton', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Brighton_final.jpeg' },
            { name: 'Bristol', coordinates: [-2.5879, 51.4545], info: 'TEFL courses in Bristol', link: '/courses/locations/england/bristol', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Bristol_final.jpg' },
            { name: 'Chelmsford', coordinates: [0.4685, 51.7356], info: 'TEFL courses in Chelmsford', link: '/courses/locations/england/chelmsford', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Chelmsford_final.jpg' },
            { name: 'Chester', coordinates: [-2.8909, 53.1934], info: 'TEFL courses in Chester', link: '/courses/locations/england/chester', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Chester_final.jpg' },
            { name: 'Exeter', coordinates: [-3.5338, 50.7184], info: 'TEFL courses in Exeter', link: '/courses/locations/england/exeter', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Exeter_final.jpeg' },
            { name: 'Guildford', coordinates: [-0.5676, 51.2362], info: 'TEFL courses in Guildford', link: '/courses/locations/england/guildford', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Guildford_final.jpg' },
            { name: 'Hull', coordinates: [-0.3367, 53.7676], info: 'TEFL courses in Hull', link: '/courses/locations/england/hull', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Hull_final.jpg' },
            { name: 'Leeds', coordinates: [-1.5486, 53.8008], info: 'TEFL courses in Leeds', link: '/courses/locations/england/leeds', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Leeds_final.jpg' },
            { name: 'Leicester', coordinates: [-1.1339, 52.6369], info: 'TEFL courses in Leicester', link: '/courses/locations/england/leicester', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Leicester_final.jpeg' },
            { name: 'Liverpool', coordinates: [-2.9785, 53.4084], info: 'TEFL courses in Liverpool', link: '/courses/locations/england/liverpool', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Liverpool_final.jpg' },
            { name: 'London', coordinates: [-0.1276, 51.5074], info: 'TEFL courses in London', link: '/courses/locations/england/london', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/London.jpg' },
            { name: 'Manchester', coordinates: [-2.2426, 53.4808], info: 'TEFL courses in Manchester', link: '/courses/locations/england/manchester', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Manchester_final.jpeg' },
            { name: 'Milton Keynes', coordinates: [-0.7558, 52.0406], info: 'TEFL courses in Milton Keynes', link: '/courses/locations/england/milton-keynes', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Milton-Keynes_final.jpg' },
            { name: 'Newcastle', coordinates: [-1.6174, 54.9783], info: 'TEFL courses in Newcastle', link: '/courses/locations/england/newcastle', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Newcastle_final.jpg' },
            { name: 'Norwich', coordinates: [1.2993, 52.6309], info: 'TEFL courses in Norwich', link: '/courses/locations/england/norwich', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Norwich_final.jpeg' },
            { name: 'Nottingham', coordinates: [-1.1510, 52.9548], info: 'TEFL courses in Nottingham', link: '/courses/locations/england/nottingham', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Nottingham_final.jpg' },
            { name: 'Plymouth', coordinates: [-4.1427, 50.3755], info: 'TEFL courses in Plymouth', link: '/courses/locations/england/plymouth', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Plymouth_final.jpg' },
            { name: 'Reading', coordinates: [-0.9781, 51.4543], info: 'TEFL courses in Reading', link: '/courses/locations/england/reading', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Reading_final.jpeg' },
            { name: 'Sheffield', coordinates: [-1.4701, 53.3811], info: 'TEFL courses in Sheffield', link: '/courses/locations/england/sheffield', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Sheffield_final.jpg' },
            { name: 'Southampton', coordinates: [-1.4044, 50.9097], info: 'TEFL courses in Southampton', link: '/courses/locations/england/southampton', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Southampton_final.jpeg' }
        ],
        nIreland: [
            { name: 'Belfast', coordinates: [-5.9301, 54.5973], info: 'TEFL courses in Belfast', link: '/courses/locations/northern-ireland/belfast', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Belfast.jpg' }
        ],
        ireland: [
            { name: 'Dublin', coordinates: [-6.2603, 53.3498], info: 'TEFL courses in Dublin', link: '/ie/courses/locations/dublin', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Dublin.jpg' },
            { name: 'Cork', coordinates: [-8.4863, 51.8985], info: 'TEFL courses in Cork', link: '/ie/courses/locations/cork', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Cork_final.jpg' },
            { name: 'Galway', coordinates: [-9.0489, 53.2707], info: 'TEFL courses in Galway', link: '/ie/courses/locations/galway', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Galway_final.jpeg' },
            { name: 'Sligo', coordinates: [-8.4711, 54.2766], info: 'TEFL courses in Sligo', link: '/ie/courses/locations/sligo', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Sligo_final.jpeg' }
        ],
        scotland: [
            { name: 'Glasgow', coordinates: [-4.2518, 55.8642], info: 'TEFL courses in Glasgow', link: '/courses/locations/scotland/glasgow', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Glasgow_final.jpeg' },
            { name: 'Edinburgh', coordinates: [-3.1883, 55.9533], info: 'TEFL courses in Edinburgh', link: '/courses/locations/scotland/edinburgh', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Edinburgh.jpg' },
            { name: 'Inverness', coordinates: [-4.2247, 57.4778], info: 'TEFL courses in Inverness', link: '/courses/locations/scotland/inverness', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Inverness_final.jpg' },
            { name: 'Aberdeen', coordinates: [-2.0943, 57.1497], info: 'TEFL courses in Aberdeen', link: '/courses/locations/scotland/aberdeen', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Aberdeen_final.jpeg' },
            { name: 'Dundee', coordinates: [-2.9707, 56.4620], info: 'TEFL courses in Dundee', link: '/courses/locations/scotland/dundee', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Dundee_final.jpeg' }
        ],
        wales: [
            { name: 'Cardiff', coordinates: [-3.1791, 51.4816], info: 'TEFL courses in Cardiff', link: '/courses/locations/wales/cardiff', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Cardiff.jpg' },
            { name: 'Swansea', coordinates: [-3.9449, 51.6214], info: 'TEFL courses in Swansea', link: '/courses/locations/wales/swansea', img:'https://cdn-wp.tefl.org/wp-content/uploads/2024/06/Swansea_final.jpg' }
        ],
        // storiesJSON: studentStories,
        // stories: [
        //   {
        //   name: 'New York',
        //   coordinates: [-74.006, 40.7128],
        //   info: 'John Doe teaching in New York',
        //   link: '/student-stories/john-doe/',
        //   img: 'https://picsum.photos/300/200?random=1'
        //   },
        //   {
        //   name: 'Tokyo',
        //   coordinates: [139.6917, 35.6895],
        //   info: 'Jane Smith teaching in Tokyo',
        //   link: '/student-stories/jane-smith/',
        //   img: 'https://picsum.photos/300/200?random=2'
        //   },
        //   {
        //   name: 'Paris',
        //   coordinates: [2.3522, 48.8566],
        //   info: 'Alice Johnson teaching in Paris',
        //   link: '/student-stories/alice-johnson/',
        //   img: 'https://picsum.photos/300/200?random=3'
        //   },
        //   {
        //   name: 'Sydney',
        //   coordinates: [151.2093, -33.8688],
        //   info: 'Bob Brown teaching in Sydney',
        //   link: '/student-stories/bob-brown/',
        //   img: 'https://picsum.photos/300/200?random=4'
        //   },
        //   {
        //   name: 'Dubai',
        //   coordinates: [55.2708, 25.2048],
        //   info: 'Emma Wilson teaching in Dubai',
        //   link: '/student-stories/emma-wilson/',
        //   img: 'https://picsum.photos/300/200?random=5'
        //   },
        //   {
        //   name: 'London',
        //   coordinates: [-0.1276, 51.5074],
        //   info: 'Michael Davis teaching in London',
        //   link: '/student-stories/michael-davis/',
        //   img: 'https://picsum.photos/300/200?random=6'
        //   },
        //   {
        //   name: 'Beijing',
        //   coordinates: [116.4074, 39.9042],
        //   info: 'Sophia Martinez teaching in Beijing',
        //   link: '/student-stories/sophia-martinez/',
        //   img: 'https://picsum.photos/300/200?random=7'
        //   },
        //   {
        //   name: 'Cape Town',
        //   coordinates: [18.4241, -33.9249],
        //   info: 'Liam Taylor teaching in Cape Town',
        //   link: '/student-stories/liam-taylor/',
        //   img: 'https://picsum.photos/300/200?random=8'
        //   },
        //   {
        //   name: 'Moscow',
        //   coordinates: [37.6173, 55.7558],
        //   info: 'Olivia Anderson teaching in Moscow',
        //   link: '/student-stories/olivia-anderson/',
        //   img: 'https://picsum.photos/300/200?random=9'
        //   },
        //   {
        //   name: 'Rio de Janeiro',
        //   coordinates: [-43.1729, -22.9068],
        //   info: 'Noah Thomas teaching in Rio de Janeiro',
        //   link: '/student-stories/noah-thomas/',
        //   img: 'https://picsum.photos/300/200?random=10'
        //   },
        //   {
        //   name: 'Mumbai',
        //   coordinates: [72.8777, 19.0760],
        //   info: 'Ava Patel teaching in Mumbai',
        //   link: '/student-stories/ava-patel/',
        //   img: 'https://picsum.photos/300/200?random=11'
        //   },
        //   {
        //   name: 'Berlin',
        //   coordinates: [13.4050, 52.5200],
        //   info: 'Lucas Schmidt teaching in Berlin',
        //   link: '/student-stories/lucas-schmidt/',
        //   img: 'https://picsum.photos/300/200?random=12'
        //   },
        //   {
        //   name: 'Toronto',
        //   coordinates: [-79.3832, 43.6532],
        //   info: 'Emily Chen teaching in Toronto',
        //   link: '/student-stories/emily-chen/',
        //   img: 'https://picsum.photos/300/200?random=13'
        //   },
        //   {
        //   name: 'Seoul',
        //   coordinates: [126.9780, 37.5665],
        //   info: 'Daniel Kim teaching in Seoul',
        //   link: '/student-stories/daniel-kim/',
        //   img: 'https://picsum.photos/300/200?random=14'
        //   },
        //   {
        //   name: 'Mexico City',
        //   coordinates: [-99.1332, 19.4326],
        //   info: 'Isabella Rodriguez teaching in Mexico City',
        //   link: '/student-stories/isabella-rodriguez/',
        //   img: 'https://picsum.photos/300/200?random=15'
        //   },
        //   {
        //   name: 'Amsterdam',
        //   coordinates: [4.9041, 52.3676],
        //   info: 'Oliver van der Berg teaching in Amsterdam',
        //   link: '/student-stories/oliver-van-der-berg/',
        //   img: 'https://picsum.photos/300/200?random=16'
        //   },
        //   {
        //   name: 'Singapore',
        //   coordinates: [103.8198, 1.3521],
        //   info: 'Zoe Tan teaching in Singapore',
        //   link: '/student-stories/zoe-tan/',
        //   img: 'https://picsum.photos/300/200?random=17'
        //   },
        //   {
        //   name: 'Cairo',
        //   coordinates: [31.2357, 30.0444],
        //   info: 'Amir Hassan teaching in Cairo',
        //   link: '/student-stories/amir-hassan/',
        //   img: 'https://picsum.photos/300/200?random=18'
        //   },
        //   {
        //   name: 'Stockholm',
        //   coordinates: [18.0686, 59.3293],
        //   info: 'Sofia Andersson teaching in Stockholm',
        //   link: '/student-stories/sofia-andersson/',
        //   img: 'https://picsum.photos/300/200?random=19'
        //   },
        //   {
        //   name: 'Bangkok',
        //   coordinates: [100.5018, 13.7563],
        //   info: 'Ethan Srisai teaching in Bangkok',
        //   link: '/student-stories/ethan-srisai/',
        //   img: 'https://picsum.photos/300/200?random=20'
        //   }
        // ]
      };
    },
    head() {
        return {
        link: [
            {
            rel: 'stylesheet',
            href: 'https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css',
            },
        ],
        script: [
                {
                hid: 'mapboxgl',
                src: 'https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.js',
                defer: true,
                // Changed after script load
                callback: () => { this.isMapboxLoaded = true } 
                }
            ]
        }
    },

    computed: {
      stories() {
        const newData = studentStories.pages.nodes.map(node => {
            // Parse the geolocationCity string into an array of numbers
            const coordinates = JSON.parse(node.geolocationCity);

            return {
              name: node.city, // Using the city as the name
              coordinates,
              info: node.title, // Using the title as info
              link: node.uri, // Using the uri as the link
              img: node.thumbnail // Using the thumbnail as the image
            };
          })
        console.log('stories', newData)
        return newData
      }
    },

    beforeUnmount() {
      if (this.map) {
        Object.values(this.markers).forEach((marker) => marker.remove());
        this.map.remove();
      }
    },

    methods: {
        visibilityChanged (isVisible, entry) {
            this.isVisible = isVisible
            if(isVisible)
            this.createMap()
        },
        
        addClusters() {
            
          // Regional settings
            let mapArray = this.england
            // let center = [-1.5, 52.8]
            // let zoom = 6
        
            if(this.$props.region === 'Scotland'){
                mapArray = this.scotland   
                // center = [-4, 56.5] 
                // zoom = 6
            }
            if(this.$props.region === 'Wales'){
                mapArray = this.wales  
                // center = [-3.7, 52.1]  
                // zoom = 7 
            }
            if(this.$props.region === 'Ireland'){
                mapArray = this.ireland    
                // center = [-7.3, 53.2] 
                // zoom = 6
            }
            if(this.$props.region === 'nIreland'){
                mapArray = this.nIreland 
                // center = [-6.5, 54.5]  
                // zoom = 7 
            }
            if(this.$props.region === 'stories'){
                mapArray = this.stories 
                // center = [0, 20]  
                // zoom = 1 
            }
          // Convert mapArray to GeoJSON
          const geojson = {
            type: "FeatureCollection",
            features: mapArray.map((city) => ({
              type: "Feature",
              properties: {
                name: city.name,
                info: city.info,
                link: city.link,
                img: city.img,
              },
              geometry: {
                type: "Point",
                coordinates: city.coordinates,
              },
            })),
          };

          // Add GeoJSON source with clustering enabled
          this.map.addSource("cities", {
            type: "geojson",
            data: geojson,
            cluster: true,
            clusterMaxZoom: 14, // Max zoom to cluster points
            clusterRadius: 50, // Radius of each cluster in pixels
          });

          // Add a layer for clusters
          this.map.addLayer({
            id: "clusters",
            type: "circle",
            source: "cities",
            filter: ["has", "point_count"],
            paint: {
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#51bbd6", 10,
                "#f1f075", 30,
                "#f28cb1",
              ],
              "circle-radius": [
                "step",
                ["get", "point_count"],
                20, 10,
                30, 30,
                40,
              ],
            },
          });

          // Add a layer for cluster labels with white text
          this.map.addLayer({
            id: "cluster-count",
            type: "symbol",
            source: "cities",
            filter: ["has", "point_count"],
            layout: {
              "text-field": "{point_count_abbreviated}",
              "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
              "text-size": 12,
            },
            paint: {
              "text-color": "#ffffff", // Set text color to white
            },
          });

          // Array to store default Mapbox markers
          this.markers = [];

          // Variable to track the currently open popup
          let currentPopup = null;

          // Function to add markers for unclustered points
          const updateMarkers = () => {
            setTimeout(() => {
            // Clear existing markers
            this.markers.forEach((marker) => marker.remove());
            this.markers = [];

            // Query unclustered points from the source
            const features = this.map.querySourceFeatures("cities", {
              filter: ["!", ["has", "point_count"]], // Only get unclustered points
            });

            features.forEach((feature) => {
              const props = feature.properties;

              // Create a default Mapbox marker and add it to the map
              const marker = new window.mapboxgl.Marker({ color: "#F76386" }) // Default marker with custom color
                .setLngLat(feature.geometry.coordinates)
                .addTo(this.map);

              // Add a popup on marker click
              marker.getElement().addEventListener("click", (e) => {
                e.stopPropagation();

                // Close any currently open popup
                if (currentPopup) currentPopup.remove();

                // Create and open a new popup
                const popup = new window.mapboxgl.Popup({ offset: 5 })
                  .setLngLat(feature.geometry.coordinates)
                  .setHTML(`
                    <h2 class="my-0">${props.name}</h2>
                    <img class="rounded-2xl my-4 mx-auto" src="${props.img}" />
                    <p>${props.info}</p>
                    <a class="button new solid w-full text-sm text-center" href="${props.link}">More info</a>
                  `)

                // Smoothly pan and zoom to ensure the popup fits on screen
                this.map.easeTo({
                  center: feature.geometry.coordinates,
                  zoom: Math.max(this.map.getZoom(), 3), // Ensure sufficient zoom level
                  offset: [0, -100], // Offset vertically so the popup doesn't overlap with the marker
                  duration: 500,     // Smooth animation duration in milliseconds
                  padding: { top: 100, bottom: 100, left: 50, right: 50 }, // Ensure padding around the popup
                });

                // Wait for the pan to complete before showing the popup
                const onMoveEnd = () => {
                  popup.addTo(this.map);
                  currentPopup = popup; // Track the currently open popup
                  this.map.off('moveend', onMoveEnd); // Remove the event listener
                };

                this.map.on('moveend', onMoveEnd);
              });

              this.markers.push(marker); // Store the marker in the array for cleanup later

              
            });
          }, 50);
          };

          // Update markers when clusters break apart or form
          this.map.on("moveend", updateMarkers);

          // Call updateMarkers when the source data is fully loaded
          this.map.on("sourcedata", (e) => {
              if (e.sourceId === "cities" && e.isSourceLoaded) {
                updateMarkers();
              }
            });

          // Zoom into clusters when clicked and update markers afterward
          this.map.on("click", "clusters", (e) => {
            const features = this.map.queryRenderedFeatures(e.point, { layers: ["clusters"] });
            const clusterId = features[0].properties.cluster_id;

            this.map.getSource("cities").getClusterExpansionZoom(clusterId, (err, zoom) => {
              if (err) return;

              this.map.easeTo({
                center: features[0].geometry.coordinates,
                zoom,
              });

              // Update markers after expanding the cluster
              updateMarkers()
            });
          });

          // Change cursor to pointer when hovering over clusters
          this.map.on("mouseenter", "clusters", () => {
            this.map.getCanvas().style.cursor = "pointer";
          });

          this.map.on("mouseleave", "clusters", () => {
            this.map.getCanvas().style.cursor = "";
          });
        },
        createMap() {

            // Regional settings
            // const mapArray = this.england
            let center = [-1.5, 52.8]
            let zoom = 6
        
            if(this.$props.region === 'Scotland'){
                // mapArray = this.scotland   
                center = [-4, 56.5] 
                zoom = 6
            }
            if(this.$props.region === 'Wales'){
                // mapArray = this.wales  
                center = [-3.7, 52.1]  
                zoom = 7 
            }
            if(this.$props.region === 'Ireland'){
                // mapArray = this.ireland    
                center = [-7.3, 53.2] 
                zoom = 6
            }
            if(this.$props.region === 'nIreland'){
                // mapArray = this.nIreland 
                center = [-6.5, 54.5]  
                zoom = 7 
            }
            if(this.$props.region === 'stories'){
                // mapArray = this.stories 
                center = [0, 20]  
                zoom = 1
            }

            window.mapboxgl.accessToken = 'pk.eyJ1IjoiamFrZXRlZmwiLCJhIjoiY2lveTg0ZW94MDBjeHZtbTJ3bmRkZzA1aCJ9.EDGQY9zwCqaxTHVGc7DK8w';
            this.map = new window.mapboxgl.Map({
                container: 'mapContainer',
                style: this.$props.mapstyle,
                center,
                zoom,
                cooperativeGestures: true
            });
            this.map.scrollZoom.disable();
            this.map.addControl(new window.mapboxgl.NavigationControl());
            this.map.on("load", () => {
              this.addClusters();
            });

            // mapArray.forEach(city => {
            //     const popup = new window.mapboxgl.Popup({ offset: 25, }).setHTML(`
            //     <h2 class="my-0">${city.name}</h2>
            //     <img class="rounded-2xl my-4 mx-auto" src="${city.img}" />
            //     <p>${city.info}</p>
            //     <a class="button new solid w-full text-sm text-center" href="${city.link}">More info</a>
            //     `);
        
            //     new window.mapboxgl.Marker({color: '#F76386'})
            //     .setLngLat(city.coordinates)
            //     .setPopup(popup)
            //     .addTo(this.map);
            // });
        },
    },
}
  